// Palco.tsx — v025: la testa delle pagine interne con l'«effetto WOW» della Home: un personaggio grande che galleggia
// nell'alone del colore della pagina, qualche stellina e il titolo nel carattere del marchio (lettere piene con il
// contorno scuro e l'ombra, come «LAUGH DOWN»). Ogni pagina ha il suo colore: Store rosa, Wall of Fame oro, Aiuto
// ciano, Accesso lilla, Profilo e Piani il colore primario.
import type { ReactNode } from "react";
import { Avatar, type Quale } from "./Avatar.tsx";
import { useFacciaCasuale } from "./Faccina.tsx";

export type ColorePalco = "rosa" | "oro" | "ciano" | "lilla" | "primario" | "menta";

interface Props {
  titolo: ReactNode;
  sottotitolo?: ReactNode;
  /** Il personaggio (un avatar, il bot…); «caso» = uno diverso a ogni apertura (v035b); null = nessuno. */
  mascotte?: Quale | "caso";
  /** Al posto del personaggio (per esempio il pulsante dell'avatar nel profilo). */
  figura?: ReactNode;
  colore?: ColorePalco;
  /** Titolo più piccolo (nomi lunghi, per esempio il nome nel profilo). */
  compatto?: boolean;
  children?: ReactNode;
}

export function Palco({ titolo, sottotitolo, mascotte, figura, colore = "primario", compatto = false, children }: Props) {
  const caso = useFacciaCasuale();
  return (
    <div className={`ld-palco ld-palco-${colore}`}>
      <span className="ld-palco-alone" aria-hidden="true" />
      {(figura || (mascotte !== undefined && mascotte !== null)) && (
        <div className="ld-palco-figura">
          <Stelline />
          {figura ?? <Avatar quale={mascotte === "caso" ? caso : mascotte} dimensione={132} classe="ld-palco-mascotte" />}
        </div>
      )}
      <h1 className={`ld-palco-titolo${compatto ? " ld-palco-titolo-compatto" : ""}`}>{titolo}</h1>
      {sottotitolo && <p className="ld-palco-sotto">{sottotitolo}</p>}
      {children}
    </div>
  );
}

function Stelline() {
  return (
    <>
      <svg className="ld-palco-stella ld-ps1" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M12 2l2.6 6.9L22 9.3l-5.8 4.6L18.2 21 12 17l-6.2 4 2-7.1L2 9.3l7.4-.4z" />
      </svg>
      <svg className="ld-palco-stella ld-ps2" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M12 2l2.6 6.9L22 9.3l-5.8 4.6L18.2 21 12 17l-6.2 4 2-7.1L2 9.3l7.4-.4z" />
      </svg>
      <span className="ld-palco-scintilla ld-pc1" aria-hidden="true" />
      <span className="ld-palco-scintilla ld-pc2" aria-hidden="true" />
      <span className="ld-palco-scintilla ld-pc3" aria-hidden="true" />
    </>
  );
}
